export default __webpack_public_path__ + "static/media/economic2.0c2773e0.jpg";